/**
 * API Configuration
 *
 * Re-exports from main config for backwards compatibility
 * All services should import from here for consistent API URL handling
 */

import { API_URL } from '../config.js';

export const API_BASE_URL = API_URL;

/**
 * Build full API URL from endpoint path
 */
export function buildApiUrl(endpoint: string): string {
  // Ensure endpoint starts with /
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;

  // If API_BASE_URL is empty (production), just return the endpoint
  if (!API_BASE_URL) {
    return normalizedEndpoint;
  }

  // Otherwise combine base URL + endpoint
  return `${API_BASE_URL}${normalizedEndpoint}`;
}
